import translate from '@allesauto/i18n';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

export interface ResultsNumberProps {
  results: number;
  text: string;
  isAccessory?: boolean;
}

const ResultsNumber: FC<ResultsNumberProps> = (props: ResultsNumberProps) => {
  const intl = useIntl();
  const { results, text, isAccessory } = props;
  const OVER_1k = results >= 1000;

  return (
    <div>
      {OVER_1k && isAccessory && (
        <span className="font-weight-normal inline-flex items-center leading-20px mr pr-5px text-p1 text-purple80 monochrome:text-grey90">
          {translate(intl, 'ui.PCP.HORIZONTAL_TOOLBAR.RESULTS_NUMBER_OVER_1K')}
        </span>
      )}
      <span className="font-weight-bold inline-flex items-center leading-20px pr-5px px-0 text-p1 text-purple80 monochrome:text-grey90">
        {intl.formatNumber(results)}
      </span>
      <span className="font-weight-normal inline-flex items-center leading-20px text-p1 text-purple80 monochrome:text-grey90">
        {text}
      </span>
    </div>
  );
};

export default ResultsNumber;
